// application/useCases/obtenerSesionAbierta.usecase.js
import {
  obtenerSesionAbiertaPorPunto,
} from "../infraestructure/supabase/cajaSesion.repository.js";

import { mapCajaSesionFromDB } from "../domain/mappers/cajaSesion.mapper.js";

export async function obtenerSesionAbiertaUseCase({ punto }) {
  if (!punto) {
    throw new Error(
      "[ObtenerSesionAbiertaUseCase] El punto es obligatorio",
    );
  }

  // 1️⃣ Consultar BD
  const sesionRow = await obtenerSesionAbiertaPorPunto(punto);

  // 2️⃣ Si no hay sesión abierta, devolver null (esto NO es error)
  if (!sesionRow) {
    return null;
  }

  // 3️⃣ Mapear a dominio
  const sesion = mapCajaSesionFromDB(sesionRow);

  return sesion;
}